import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "calendar-container" }
const _hoisted_2 = { class: "calendar-header" }
const _hoisted_3 = { class: "header-content" }
const _hoisted_4 = { class: "header-actions" }
const _hoisted_5 = { class: "stat-content" }
const _hoisted_6 = { class: "stat-value" }
const _hoisted_7 = { class: "stat-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_DxLoadPanel = _resolveComponent("DxLoadPanel")!
  const _component_DxScheduler = _resolveComponent("DxScheduler")!
  const _component_v_card_text = _resolveComponent("v-card-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "header-text" }, [
          _createElementVNode("h1", { class: "calendar-title" }, "Calendar Activități"),
          _createElementVNode("p", { class: "calendar-subtitle" }, "Gestionează întâlniri, apeluri și evenimente")
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_v_btn, {
            color: _ctx.APP_Color,
            "prepend-icon": "mdi-refresh",
            variant: "text",
            onClick: _ctx.refreshCalendar
          }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode(" Actualizează ", -1)
            ]))]),
            _: 1
          }, 8, ["color", "onClick"]),
          _createVNode(_component_v_btn, {
            color: _ctx.APP_Color,
            "prepend-icon": "mdi-plus",
            variant: "elevated"
          }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createTextVNode(" Eveniment Nou ", -1)
            ]))]),
            _: 1
          }, 8, ["color"])
        ])
      ])
    ]),
    _createVNode(_component_v_row, { class: "stats-row" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.quickStats, (stat, index) => {
          return (_openBlock(), _createBlock(_component_v_col, {
            key: index,
            cols: "12",
            sm: "6",
            md: "3"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                class: "stat-card",
                elevation: "2"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "stat-icon-wrapper",
                    style: _normalizeStyle({ background: stat.bgColor })
                  }, [
                    _createVNode(_component_v_icon, {
                      color: stat.color,
                      size: "28"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(stat.icon), 1)
                      ]),
                      _: 2
                    }, 1032, ["color"])
                  ], 4),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, _toDisplayString(stat.value), 1),
                    _createElementVNode("div", _hoisted_7, _toDisplayString(stat.label), 1)
                  ])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }),
    _createVNode(_component_v_card, {
      class: "calendar-card",
      elevation: "2"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card_title, { class: "card-title" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, {
              color: _ctx.APP_Color,
              size: "24",
              class: "mr-2"
            }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createTextVNode("mdi-calendar-month", -1)
              ]))]),
              _: 1
            }, 8, ["color"]),
            _cache[4] || (_cache[4] = _createElementVNode("span", null, "Calendar", -1))
          ]),
          _: 1
        }),
        _createVNode(_component_v_card_text, { class: "pa-4" }, {
          default: _withCtx(() => [
            _createVNode(_component_DxScheduler, {
              ref: "dataGridRef",
              "time-zone": "Europe/Bucharest",
              "data-source": _ctx.dataSource,
              "date-serialization-format": "yyyy-MM-ddTHH:mm:ssZ",
              "current-date": _ctx.currentDate,
              views: _ctx.views,
              height: 650,
              "start-day-hour": 9,
              "end-day-hour": 19,
              "start-date-expr": "StartDate",
              "end-date-expr": "EndDate",
              "all-day-expr": "AllDay",
              "text-expr": "Subject",
              "description-expr": "Description",
              "label-expr": "Label",
              "reminder-rule-expr": "ReminderInfo",
              "recurrence-rule-expr": "RecurrenceInfo",
              "current-view": "month",
              onAppointmentDeleted: _ctx.showDeletedToast
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DxLoadPanel, {
                  enabled: true,
                  "indicator-src": 'reload6.gif'
                })
              ]),
              _: 1
            }, 8, ["data-source", "current-date", "views", "onAppointmentDeleted"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}